import { Schema } from '@/types/general';

interface FormData {
  [key: string]: any;
}
export default () => {
  /**
   * Validates the the given form contains all mandatory fields
   * @param formData
   * @param schema
   * @param debug (optional value to toggle console.debugs, default: false)
   * @returns
   */
  function mandatoryFieldValidator(formData: FormData, schema: Schema, debug = false): boolean {
    if (debug) console.debug('mandatory fields', schema.required, schema);
    if (schema.required !== undefined) {
      for (const field of schema.required) {
        if (!formData[field]) {
          if (debug) console.debug(`field ${field} is mandatory`, formData);
          return false;
        }
      }
    }

    const requiredSubSchemas = Object.fromEntries(
      Object.entries(schema.properties).filter(
        ([key, value]) => schema.required?.includes(key) && value.type === 'object'
      )
    );

    return Object.entries(requiredSubSchemas).every(([key, value]) => {
      const subSchema = value as Schema;
      return mandatoryFieldValidator(formData[key], subSchema, debug);
    });
  }

  function validateSchemaPatterns(formData: FormData, schema: Schema, debug = false): boolean {
    // if there are no properties, then we cannot validate so we return true
    if (!schema.properties) return true;

    return Object.entries(schema.properties).every(([key, value]) => {
      if (debug) console.debug(`key: ${key} value.type: ${value.type}`);
      if (debug) console.debug(`   formData[${key}] & value`, formData[key], value);
      switch (value.type) {
        case 'string':
          const regexPattern = new RegExp((value as any).pattern);
          if (![undefined, ''].includes(formData[key]) && !regexPattern.test(formData[key])) {
            if (debug) console.warn(`failed to match ${formData[key]} with ${regexPattern}`);
            return false;
          } else {
            return true;
          }
        case 'array':
          return (
            formData[key] !== undefined &&
            formData[key] !== '' &&
            (formData[key] as Array<any>).every((item) => validateSchemaPatterns(item, value.items as Schema))
          );
        default:
          if (!!formData[key] && formData[key] !== '') {
            if (debug) console.debug(`recursive key: ${key} value.type: ${value.type}`, value, formData[key]);
            const valid = validateSchemaPatterns(formData[key], value as Schema);
            if (debug) console.debug(`recursive key: ${key} value.type: ${value.type} valid: ${valid}`);
            return valid;
          } else {
            return true;
          }
      }
    });
  }

  return {
    mandatoryFieldValidator,
    validateSchemaPatterns
  };
};
